import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRewardsDashboardState } from '@shared/models';
import * as Response from '@shared/models/rewards/rewards.response.type';
import { fetchRewardDashboardSections } from '../queries';

const state: IRewardsDashboardState = {
    fetching: false,
    data: {
        rewardPurchases: [],
        rewards: [],
        recordingPurchases: [],
        coinsHistory: [],
        apps: [],
        webinars: [],
        workshops: [],
        resources: [],
    },
    activeReward: null,
};

const rewardDashboardSlice = createSlice({
    name: 'reward-dashboard',
    initialState: state,
    reducers: {
        setRewardDashboardSections: (state, { payload }: PayloadAction<Response.IRewardDashboard>) => {
            state.data = payload;
        },
        setActiveReward: (state, { payload }: PayloadAction<Response.IReward>) => {
            state.activeReward = payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchRewardDashboardSections.pending, (state) => {
            state.fetching = true;
        });
        builder.addCase(fetchRewardDashboardSections.rejected, (state) => {
            state.fetching = false;
        });
        builder.addCase(fetchRewardDashboardSections.fulfilled, (state) => {
            state.fetching = false;
        });
    },
});

export const { setRewardDashboardSections, setActiveReward } = rewardDashboardSlice.actions;
export default rewardDashboardSlice.reducer;
